import type { DocCategory } from '../../types/docops';

export const SEED_CATEGORIES: DocCategory[] = [
  {
    id: 'user-facing-legal',
    name: 'User-Facing Legal',
    description: 'Published policies visible to platform users',
    icon: '📜',
    color: '#8B0000',
    sortOrder: 1,
    documentCount: 8,
  },
  {
    id: 'corporate-formation',
    name: 'Corporate / Entity',
    description: 'LLC formation, governance, board resolutions',
    icon: '🏛️',
    color: '#2F4F4F',
    sortOrder: 2,
    documentCount: 6,
  },
  {
    id: 'trust-ip',
    name: 'Trust & IP Licensing',
    description: 'Family trust, IP assignment, license agreement',
    icon: '🔐',
    color: '#4B0082',
    sortOrder: 3,
    documentCount: 8,
  },
  {
    id: 'mso-pc',
    name: 'MSO / PC Structure',
    description: 'Management services, medical director, compliance',
    icon: '🏥',
    color: '#006400',
    sortOrder: 4,
    documentCount: 6,
  },
  {
    id: 'hipaa',
    name: 'HIPAA Compliance',
    description: 'BAAs, internal policies, training, risk assessment',
    icon: '🛡️',
    color: '#8B4513',
    sortOrder: 5,
    documentCount: 13,
  },
  {
    id: 'vendor-partner',
    name: 'Vendor / Partner',
    description: 'Telehealth network, pharmacy, fulfillment, processing',
    icon: '🤝',
    color: '#191970',
    sortOrder: 6,
    documentCount: 6,
  },
  {
    id: 'employment-contractor',
    name: 'Employment / Contractor',
    description: 'CEO agreement, offer letters, NDAs, equity grants',
    icon: '👥',
    color: '#556B2F',
    sortOrder: 7,
    documentCount: 8,
  },
  {
    id: 'compliance-ops',
    name: 'Compliance Operations',
    description: 'Data ops, breach response, incident runbooks, DR plan',
    icon: '⚙️',
    color: '#800020',
    sortOrder: 8,
    documentCount: 9,
  },
  {
    id: 'dashboards-tools',
    name: 'Dashboards & Tools',
    description: 'Admin dashboards, monitoring systems, notification pipeline',
    icon: '📊',
    color: '#2E8B57',
    sortOrder: 9,
    documentCount: 4,
  },
  {
    id: 'business-planning',
    name: 'Business Planning',
    description: 'Staffing, structure playbook, positioning, acquisition',
    icon: '📈',
    color: '#4169E1',
    sortOrder: 10,
    documentCount: 6,
  },
  {
    id: 'acquisition-dataroom',
    name: 'Acquisition / Data Room',
    description: 'Pitch deck, financial model, data room, cap table',
    icon: '💰',
    color: '#DAA520',
    sortOrder: 11,
    documentCount: 7,
  },
  {
    id: 'clinical',
    name: 'Clinical',
    description: 'Protocols, formulary, escalation criteria, AI skill plan',
    icon: '🧬',
    color: '#DC143C',
    sortOrder: 12,
    documentCount: 5,
  },
  {
    id: 'soc2-infosec',
    name: 'SOC 2 / Information Security',
    description: 'Security policies, access control, change management, vendor management, risk assessment',
    icon: '🔒',
    color: '#1a5276',
    sortOrder: 13,
    documentCount: 10,
  },
];
